export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6625.2858b373.jpg";